import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createOvermind } from "overmind";
import { Provider } from "overmind-react";
import { config } from "./presenter";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
export const overmind = createOvermind(config, {
  devtools: false,
  onInitialize: ({ state }) => {
    // set initial state from localStorage on app mount
    state.user = JSON.parse(localStorage.getItem('user')) || null;
    state.accessToken = localStorage.getItem('accessToken') || null;
  },
});
root.render(
  <Provider value={overmind}>
    <ToastContainer
      position="top-center"
      hideProgressBar={true}
    />
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
